import axios from './BaseService';

const ARGOS_TRADERBOT_URL = `${
    process.env.REACT_APP_API_URL || window._env_?.REACT_APP_API_URL
}/argostraderbot/`;

export async function getDashboard() {
    const response = await axios.get(ARGOS_TRADERBOT_URL + 'dashboard');
    return response.data;
}
